type TTeamWithMembers = { Members: Array<{ id: string }> };

export const withTeamMembers = <T extends TTeamWithMembers>(
  team: T | undefined,
  addedMembers: readonly T['Members'][number][],
): T | undefined => {
  if (!team || addedMembers.length === 0) {
    return team;
  }

  const present = new Set(team.Members.map((member) => member.id));

  return { ...team, Members: [...team.Members, ...addedMembers.filter((member) => !present.has(member.id))] };
};
